var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup19839(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 409,
    viewBox: "0 0 330 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.5425,
    y: 113.689,
    width: 72.5057,
    height: 345.127,
    rx: 36.2528,
    transform: "rotate(45 94.5425 113.689)",
    fill: "#6DB8FF",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.0417,
    width: 72.5057,
    height: 345.127,
    rx: 36.2528,
    transform: "rotate(45 80.0417 0)",
    fill: "#6DB8FF",
    fillOpacity: 0.08
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 278.417,
    y: 62.3562,
    width: 72.5057,
    height: 345.127,
    rx: 36.2528,
    transform: "rotate(45 278.417 62.3562)",
    fill: "#6DB8FF",
    fillOpacity: 0.08
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19839);
export default __webpack_public_path__ + "static/media/Group 19839.f6a8761c81322da185c93c176d52eb56.svg";
export { ForwardRef as ReactComponent };